import '../types/externs'
import whichStream from './'

module.exports = whichStream